import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { Body2 } from '@estee/elc-typography';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { ContentSpacing } from '@estee/elc-base-theme';
import { ProductNotifyMePopupNoticeTheme } from '../../../theme/default-theme';

export interface IProductNotifyMeConfirmation {
    translations?: ITranslationsCollection;
    isGdprPopupOpen?: boolean;
}

const ProductNotifyMeInfoPopupWrapper = styled.div`
    position: absolute;
    left: 0;
    bottom: ${ContentSpacing.space24};
    padding: ${ContentSpacing.space20};
    ${ProductNotifyMePopupNoticeTheme}
`;

const productGdprPopupClassNames = ['elc-product-gdpr-popup', 'js-product-gdpr-popup'];
const productGdprPopupActiveClassNames = classnames(...productGdprPopupClassNames, 'active');
const productGdprPopupInactiveClassNames = classnames(productGdprPopupClassNames);

const productGdprPopupInformationClassNames = classnames(
    'elc-product-gdpr-popup-information',
    'js-product-gdpr-popup-information'
);

export const ProductNotifyMeInfoPopup: React.FunctionComponent<IProductNotifyMeConfirmation> = translate(
    ['gdprNoticeInformation']
)(
    observer((props: IProductNotifyMeConfirmation) => {
        const { gdprNoticeInformation } = props.translations as ITranslationsCollection;
        const productGdprPopupWrapperClassNames = props.isGdprPopupOpen
            ? productGdprPopupActiveClassNames
            : productGdprPopupInactiveClassNames;

        return (
            <ProductNotifyMeInfoPopupWrapper className={productGdprPopupWrapperClassNames}>
                <Body2
                    className={productGdprPopupInformationClassNames}
                    dangerouslySetInnerHTML={{ __html: gdprNoticeInformation }}
                />
            </ProductNotifyMeInfoPopupWrapper>
        );
    })
);
